import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Input, Row, Typography } from "antd";
import { Icon } from "assets/icons";
import CustomModal from "components/CustomModal";
import CustomTable from "components/CustomTable";
import RadioGroup from "features/Warranty/WarrantyList/component/RadioGroup";
import SellerTagList from "pages/App/Agent/List/components/SellerTagList";
import React from "react";
import "./index.scss";
import useAgentPickerModal from "./useAgentPickerModal";

export const AgentPickerModal = ({ visible, onCancel, onOk, initialSelectedRowKeys, initialSelectedRows }) => {
  const {
    filterItemsTypeOptions,
    rowSelection,
    loading,
    columns,
    isFilterSelected,
    setIsFilterSelected,
    selectedRows,
    dataSeller,
    paginationData,
    handleSearch,
    handleChange,
    onTableChange,
    handleCloseTag,
    params,
  } = useAgentPickerModal();

  // Set initial selectedRowKeys và tự động chọn tab "Đã chọn" khi mở từ "Xem chi tiết"
  React.useEffect(() => {
    if (visible) {
      if (initialSelectedRowKeys && initialSelectedRowKeys.length > 0) {
        // Tự động chọn tab "Đã chọn" khi có initialSelectedRowKeys (mở từ "Xem chi tiết")
        setIsFilterSelected(true);
        // Dùng initialSelectedRows nếu có (full list), nếu không thì tìm từ dataSeller (current page)
        const rowsToSet =
          initialSelectedRows ||
          (dataSeller ? dataSeller.filter((seller) => initialSelectedRowKeys.includes(seller.id)) : []);
        if (rowsToSet.length > 0 || initialSelectedRowKeys.length > 0) {
          // Set selectedRows
          rowSelection.onChange(initialSelectedRowKeys, rowsToSet);
        }
      } else {
        // Reset về rỗng nếu không có initial keys
        setIsFilterSelected(false);
        rowSelection.onChange([], []);
      }
    } else {
      // Reset khi modal đóng (tùy chọn - có thể giữ state hoặc reset)
      // setIsFilterSelected(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible, initialSelectedRowKeys, initialSelectedRows]);

  // Handler onOk để truyền selectedRows ra ngoài
  const handleOk = () => {
    onOk?.(selectedRows || []);
  };

  const dataSource = isFilterSelected ? selectedRows : dataSeller;

  return (
    <div className="custom-modal-select-product">
      <CustomModal
        {...{
          message: <Typography.Title level={4}>Chọn đại lý tham gia mức ưu đãi [x]</Typography.Title>,
          footer: false,
          width: "70%",
          visible: visible,
          onCancel: onCancel,
          onOke: handleOk,
          buttonLoading: loading,
          okeButtonLabel: "Lưu lại",
          children: (
            <>
              <Row
                gutter={[16, 4]}
                style={{
                  alignItems: "center",
                  borderRadius: "8px",
                  margin: 0,
                }}
              >
                <Col span={24} style={{ marginBottom: "12px" }}>
                  <Row gutter={[16]} style={{ alignItems: "flex-end" }}>
                    <Col span={14}>
                      <div className="custom-search-product-wrapper">
                        {!isFilterSelected && (
                          <Input
                            prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
                            placeholder="Tìm kiếm theo mã đại lý hoặc tên đại lý"
                            onChange={handleSearch}
                            allowClear={true}
                            style={{ width: "350px" }}
                          />
                        )}
                      </div>
                    </Col>
                    <Col span={10} style={{ paddingTop: "30px" }}>
                      <RadioGroup
                        filterItemsTypeOptions={filterItemsTypeOptions}
                        handleChange={handleChange}
                        isUpdate={true}
                        value={isFilterSelected}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>{" "}
              <Col span={24}>
                <SellerTagList filters={params.filters} onClose={handleCloseTag} />
              </Col>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <CustomTable
                    rowSelection={{
                      type: "checkbox",
                      ...rowSelection,
                    }}
                    columns={columns}
                    loading={loading}
                    dataSource={dataSource}
                    rowKey={(record) => record?.id}
                    onChange={onTableChange}
                    pagination={{
                      total: isFilterSelected ? selectedRows?.length : paginationData?.total,
                      pageSize: paginationData?.limit,
                      current: paginationData?.offset / paginationData?.limit + 1 || 1,
                      showSizeChanger: false,
                    }}
                    scroll={{ x: "max-content", y: "500px" }}
                  />
                </Col>
              </Row>
            </>
          ),
        }}
      />
    </div>
  );
};
